import { gql } from "@apollo/client"

const GROUP_FRAGMENTS = {
  groupDetail: gql`
    fragment GroupDetailFrag on GroupType {
      id
      name
      userCount
      permissions {
        id
        name
        codename
      }
    }
  `,
}
const ADD_UPDATE_GROUP = gql`
  mutation AddGroupMutation($id: Int, $name: String!, $permissions: [Int!]) {
    addGroup(id: $id, name: $name, permissions: $permissions) {
      group {
        ...GroupDetailFrag
      }
    }
  }
  ${GROUP_FRAGMENTS.groupDetail}
`

const GROUP_LIST = gql`
  query allGroupsList {
    allGroups {
      ...GroupDetailFrag
    }
  }
  ${GROUP_FRAGMENTS.groupDetail}
`
const GROUP_DETAILS = gql`
  query getGroupDetails($id: Int, $groupName: String) {
    groupDetails(groupId: $id, groupName: $groupName) {
      ...GroupDetailFrag
    }
  }
  ${GROUP_FRAGMENTS.groupDetail}
`

const DELETE_GROUP = gql`
  mutation deleteGroup($id: Int!) {
    delGroup(groupId: $id) {
      groupId
    }
  }
`
export { ADD_UPDATE_GROUP, GROUP_LIST, GROUP_DETAILS, DELETE_GROUP }
